import { http } from '@/api/client/httpClient';

// ABP Feature Management. Tenant features use providerName "T", providerKey = tenant id.
export interface FeatureValueType {
  name: string; // e.g. ToggleStringValueType, FreeTextStringValueType, SelectionStringValueType
  itemSource?: { items?: Array<{ value: string; displayText?: { name?: string } | string | null }> } | null;
}

export interface FeatureDto {
  name: string;
  displayName: string;
  value: string | null;
  description?: string | null;
  valueType?: FeatureValueType | null;
  parentName?: string | null;
}

export interface FeatureGroupDto {
  name: string;
  displayName: string;
  features: FeatureDto[];
}

export interface FeatureListResultDto {
  groups: FeatureGroupDto[];
}

const BASE = '/api/feature-management/features';

export const featureManagementApi = {
  async getTenantFeatures(tenantId: string): Promise<FeatureListResultDto> {
    const { data } = await http.get<FeatureListResultDto>(BASE, {
      params: { providerName: 'T', providerKey: tenantId },
    });
    return data;
  },
  async updateTenantFeatures(
    tenantId: string,
    features: { name: string; value: string | null }[],
  ): Promise<void> {
    await http.put(BASE, { features }, { params: { providerName: 'T', providerKey: tenantId } });
  },
  async resetTenantFeatures(tenantId: string): Promise<void> {
    await http.delete(BASE, { params: { providerName: 'T', providerKey: tenantId } });
  },
};

export function isToggle(f: FeatureDto): boolean {
  return (f.valueType?.name ?? '').toLowerCase().includes('toggle');
}

export function isOn(value: string | null): boolean {
  return (value ?? '').toLowerCase() === 'true';
}

export function isSelection(f: FeatureDto): boolean {
  return (f.valueType?.name ?? '').toLowerCase().includes('selection');
}

export function selectionItems(f: FeatureDto): { value: string; label: string }[] {
  return (f.valueType?.itemSource?.items ?? []).map((it) => ({
    value: it.value,
    label: typeof it.displayText === 'string' ? it.displayText : it.displayText?.name ?? it.value,
  }));
}
